import { useContext } from "react"
import tw from "twin.macro"
import { LanguageContext } from "../../../../contexts/Language"
import { toUsd, vehicleCategory } from "../../../../helpers"
import { css } from "@emotion/react"
import { TrimCardProps } from "./AllVehicleExpandedSelectorModuleProps"
import { Image } from "../../../atoms/Image"
import useTealiumEvent from "../../../../hooks/Tealium/useTealiumEvent"

const TrimCard: React.FC<TrimCardProps> = ({
  model,
  trim,
  index,
  showCompare,
  isSelected,
  selectedTrims,
  setSelectedTrims,
}) => {
  const { _ } = useContext(LanguageContext)
  const { trackTealEvent } = useTealiumEvent()

  return (
    <div css={[tw`w-full mx-2 md:(w-[350px] mx-0) lg:(w-[420px]) relative`]}>
      {showCompare && (
        <div css={[tw`absolute top-5 right-5 flex items-center`]}>
          <input
            className="peer"
            type="checkbox"
            css={[
              tw`h-6 w-6 appearance-none cursor-pointer border-2 border-gray-800 rounded-sm opacity-100 order-2`,
              tw`checked:(border-toyotaRed) `,
              tw`disabled:(opacity-60 pointer-events-none)`,
              css`
                &:checked::after {
                  content: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="%23eb0a1e" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check"><polyline points="20 6 9 17 4 12"/></svg>');
                  display: block;
                  text-align: center;
                  color: #ff0000; /* Toyota Red */
                  font-size: 1rem;
                }
              `,
            ]}
            disabled={
              (!isSelected && selectedTrims?.length >= 3) ||
              trim?._type === "customModel"
            }
            checked={isSelected}
            onChange={e => {
              if (e.target.checked) {
                setSelectedTrims([...selectedTrims, trim])
                trackTealEvent({
                  tealium_event: "compare_add",
                  vehicle_model: model,
                  vehicle_trim: trim.name,
                  vehicle_trim_id: trim.code,
                  vehicle_powertrain: trim.fuelType,
                  vehicle_segment_vehicle_page: vehicleCategory(model),
                  vehicle_model_truncated: model,
                })
              } else {
                selectedTrims &&
                  setSelectedTrims(
                    selectedTrims.filter(t => t.code !== trim.code),
                  )
              }
            }}
            analytics-id={`compare check:all segment:${index}`}
          />
          <label
            css={[
              tw`text-xs uppercase mr-3 font-semibold order-1`,
              tw`peer-disabled:opacity-60`,
            ]}
          >
            {_("Compare")}
          </label>
        </div>
      )}
      <div
        css={[
          tw`w-full h-[280px] md:w-[300px] lg:(w-[400px] h-[312px]) rounded-2xl bg-wildSand pt-12 px-8 mx-auto`,
        ]}
      >
        <p css={[tw`font-semibold`]}> {trim?.name}</p>
        <p css={[tw`text-sm`]}> {`$${toUsd(trim?.costs?.baseMSRP)} msrp`}</p>
        <Image
          css={[tw`pointer-events-none`]}
          imageData={trim?.jellybean || trim?.hotspotsAngle3?.image}
        />
      </div>
    </div>
  )
}

export default TrimCard
